import { Account } from "@city-sage/core-client";
import { cn, Image } from "@city-sage/aurum-avis-labs-components";

export function Avatar({ account, className = 'h-10 w-10', textClassName = 'font-medium' }: { account: Account, className?: string, textClassName?: string }) {
  return (
<div className={cn("relative overflow-hidden rounded-full", className)}>
            {account.avatarUrl ? (
              <Image
                src={account.avatarUrl}
                alt={account?.userName || 'User'}
                className="object-cover w-full h-full"
              />
            ) : (
              <div className={cn("w-full h-full bg-gray-200 flex items-center justify-center text-gray-600", textClassName)}>
                {account?.userName?.slice(0, 2).toUpperCase() || 'AN'}
              </div>
            )}
          </div>
  );
}